<header>
  <mat-toolbar
    class="sp-toolbar"
    [ngClass]="width_class">
    <mat-toolbar-row class="sp-row__space">
      <div class="sp-row__align">
        <img
          src="../../../assets/img/logo/sp-logo-dark.svg"
          class="sp-logo__m sp-hidden__after-lg" />

        <mat-icon
          color="primary"
          class="sp-hidden__before-lg">
          {{ current_nav_item?.icon }}
        </mat-icon>

        <span
          class="sp-color__primary sp-hidden__before-lg"
          style="margin-left: 4px">
          <i> {{ current_nav_item?.label || '' | translate }} </i>
        </span>
      </div>

      <div class="sp-row__align">
        <app-shared-profile
          [seller_label]="getProfileLabel()"
          [seller_email]="getProfileEmail()"
          [is_seller_email_visible]="true"></app-shared-profile>

        <app-toolbar-mobile-menu
          class="sp-hidden__after-lg"
          [current_nav_item]="current_nav_item"></app-toolbar-mobile-menu>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
</header>
